var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.invitations.length !== 0
    ? _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                { staticClass: "rounded-0" },
                [
                  _c("h4", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.adminUserInvitation.title")) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      responsive: "",
                      fields: _vm.fields,
                      items: _vm.invitations,
                      "tbody-class": "text-muted"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "createdAt",
                        fn: function(row) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm
                                    .$moment(row.item.createdAt, "YYYY-MM-DD")
                                    .format("DD.MM.YYYY")
                                ) +
                                "\n        "
                            )
                          ]
                        }
                      },
                      {
                        key: "status",
                        fn: function(row) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    "enums.invitationStatus." + row.item.status
                                  )
                                ) +
                                "\n        "
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-167d129a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167d129a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/AdminUserInvitation.vue
// module id = jm9Z
// module chunks = 1